export default __webpack_public_path__ + "static/media/dashboard.b081d95d.png";